import { FormControl } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { AnimatePresence } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import ReactSelect from "react-select";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import ModalUsuarioMotorista from "../../../components/ModalUsuarioMotorista/ModalUsuarioMotorista.tsx";
import ModalVincular from "../../../components/ModalVincular/ModalVincular.tsx";
import { TabelaVirtualizadaGenerica } from "../../../components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import Text from "../../../components/Text/Text";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	cnhValido,
	documentoValido,
	telefoneValido,
} from "../../../core/utils/validators.ts";
import { useRowClick } from "../../../hooks/useRowClick.ts";
import { MotoristaModel } from "../../../models/MotoristaModels";
import { cpfMask } from "../../../regex/cpfMask.js";
import { telefoneMask } from "../../../regex/telefoneMask";
import {
	cadastraMotorista,
	deleteMotoristaPorId,
	editaMotoristaPorId,
	getMotoristaPorId,
} from "../../../services/ModuloGerenciador/Motorista";
import { getMotorista } from "../../../services/ModuloGerenciador/Motorista.ts";
import { getMotoristaSearch } from "../../../services/ModuloGerenciador/Search";
import {
	getUserClientes,
	vincularUsuario,
} from "../../../services/ModuloGerenciador/Usuario";
import { VerificaExistenciaMotorista } from "../../../services/ModuloGerenciador/VerificaExistencia";
import TipoObservacao from "../../ModuloGerenciador/UsoComum/TipoObservacao/TipoObservacao.js";
import TipoContatoProp from "../UsoComum/TipoContatoProp/TipoContatoProp.js";
import "./Motorista.css";
import MotoristaEndereco from "./MotoristaEndereco.js";
import { formatMotora } from "./MotoristaUtil.js";

const itensFiltro = [
	{
		nomeColuna: "Nome Motorista",
		field: "nome",
	},
	{
		nomeColuna: "Número Documento",
		field: "numeroDocumento",
	},
	{
		nomeColuna: "Tipo Documento",
		field: "tipoDocumento",
	},
	{
		nomeColuna: "Telefone",
		field: "telefone",
	},
	{
		nomeColuna: "Pessoa Emergência",
		field: "nomeEmergencia",
	},
	{
		nomeColuna: "Telefone Emergência",
		field: "telefoneEmergencia",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
];

const opcoes = [
	{
		opcao: "CPF",
	},
	{
		opcao: "CNH",
	},
];

function Motorista(props) {
	const { profile, hasRegra, tabelaEmpresa, shouldSearchDependencies } =
		useProfile();
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);
	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);
	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);
	const [dadosTabela, setDadosTabela] = useState([]);
	const [dadosUsuarioMotorista] = useState([]);
	const [telaCadastro, setTelaCadastro] = useState(false);
	const [editando, setEditando] = useState(false);
	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState(new MotoristaModel({}));
	const [validator, setValidator] = useState({
		nome: "true",
		telefone: "true",
		telefoneContato: "true",
		numeroDocumento: "true",
		nomeEmergencia: "true",
		rg: "true",
		validatorRua: "true",
		validatorCidade: "true",
		validatorCep: "true",
		validatorNumero: "true",
		validatorBairro: "true",
	});
	const [valuesSelect, setValuesSelect] = useState([]);
	const [open, setOpen] = useState(false);
	const [textoSucesso, setTextoSucesso] = useState("");
	const [textoErro, setTextoErro] = useState("");
	const [textoErroNome, setTextoErroNome] = useState("");
	const [valuesPesquisa, setValuesPesquisa] = useState([]);
	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);
	const [, setVerificaMotivo] = useState(true);

	const hasBuscadoMotoristaId = useRef(false);

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idMotorista === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada]
	);

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row["idMotorista"] ?? row.idMotorista,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux]
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, []);

	const handleRowClick = useRowClick({
		idKey: "idMotorista",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const handleChangePhone = useCallback((e) => {
		if (e.target.value.length > 14) return;
		setValues((current) => ({
			...current,
			telefone: telefoneMask(e.target.value),
		}));
		setValidator((current) => ({
			...current,
			telefone: "true",
		}));
	}, []);

	const handleChangePhoneEmergencia = useCallback((e) => {
		if (e.target.value.length > 14) return;
		setValues((current) => ({
			...current,
			telefoneEmergencia: telefoneMask(e.target.value),
		}));
		setValidator((current) => ({
			...current,
			telefoneContato: "true",
		}));
	}, []);

	const handleChangeDocumento = useCallback(
		(e) => {
			let valorMascara = e.target.value;
			if (values.tipoDocumento === "CPF" && e.target.value.length <= 14) {
				valorMascara = cpfMask(e.target.value);
			} else if (values.tipoDocumento === "CNH") {
				valorMascara = e.target.value.replace(/\D/g, "").slice(0, 11);
			}

			setValues((current) => ({
				...current,
				numeroDocumento: valorMascara,
			}));
			setValidator((current) => ({
				...current,
				documento: "true",
			}));
		},
		[values]
	);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const [openUsuarioMotorista, setOpenUsuarioMotorista] = useState(false);

	const handleCloseUsuarioMotorista = (value) => {
		setOpenUsuarioMotorista(false);
		setOpenConfirmar(false);
		buscarMotorista();
	};

	const abrirConfirmar = (value) => {
		setOpenConfirmar(true);
	};

	const [openConfirmar, setOpenConfirmar] = useState(false);

	const handleCloseConfirmar = (value) => {
		setOpenConfirmar(false);
	};

	const clickGerar = () => {
		gerarUsuario();
	};

	const [listaUsuarios, setListaUsuario] = useState([]);

	const [usuarioId, setUsuarioId] = useState();

	const [setNomeUsuario] = useState();

	const [openGerar, setOpenGerar] = useState(false);

	const handleCloseGerar = (value) => {
		setOpenGerar(false);
	};

	const preencherDadosEditando = async (result) => {
		let tipoDocumento;
		if (result.tipoDocumento === "CPF") {
			tipoDocumento = "CPF";
		} else if (result.tipoDocumento === "CNH") {
			tipoDocumento = "CNH";
		}
		const tipoDocumentoSelecionado = opcoesFrota.find(
			(option) => option.value === tipoDocumento
		);
		if (tipoDocumentoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoDocumento: tipoDocumentoSelecionado,
			}));
		}
	};

	const buscarMotorista = async () => {
		setLoading(true);
		await getMotorista({ token: profile?.token })
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Motorista";
		if (telaCadastro) return "Cadastro de Motorista";
		return "Motoristas";
	}, [editando, telaCadastro]);

	const verificadorExistenciaMotorista = async (motorista) => {
		if (!editando || values.nomeBackup !== motorista) {
			setOpenToastErro(false);
			setOpenToastSucesso(false);
			if (motorista !== null && motorista !== "") {
				await VerificaExistenciaMotorista(profile?.token, motorista)
					.then((result) => {
						if (result.data === true) {
							setTextoSucesso("Motorista ainda não cadastrado.");
							setOpenToastSucesso(true);
							setValidator((current) => ({ ...current, nome: "true" }));
						} else {
							setTextoErro("Motorista já cadastrado com esse nome.");
							setOpenToastErro(true);
							setValidator((current) => ({ ...current, nome: "false" }));
							setTextoErroNome("Motorista já cadastrado com esse nome.");
						}
					})
					.catch(() => {
						setTextoErro("Motorista já cadastrado com esse nome.");
						setOpenToastErro(true);
						setValidator((current) => ({ ...current, nome: "false" }));
						setTextoErroNome("Motorista já cadastrado com esse nome.");
					});
			}
		}
	};

	const buscarUsuariosClientes = async () => {
		await getUserClientes(profile?.token)
			.then((result) => {
				setListaUsuario(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const gerarUsuario = async () => {
		const usuarioVinculo = {
			motoristaId: tabelaRedux.colunaSelecionada,
			usuarioClientesId: usuarioId,
		};
		await vincularUsuario(usuarioVinculo, profile?.token)
			.then((result) => {
				setOpenGerar(false);
				buscarMotorista();
				setTextoSucesso("Vinculado Com Sucesso");
				setOpenToastSucesso(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const validarTelefones = useCallback(() => {
		if (!telefoneValido(values.telefone)) {
			setValidator((current) => ({ ...current, telefone: "false" }));
			return false;
		}

		if (!telefoneValido(values.telefoneEmergencia)) {
			setValidator((current) => ({ ...current, telefoneContato: "false" }));
			return false;
		}

		return true;
	}, [values]);

	const buscarSearch = useCallback(async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getMotoristaSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [valuesPesquisa, multiplosFiltrosRedux, profile]);

	const cadastrar = useCallback(async () => {
		setOpenToastErro(false);

		if (!validarTelefones()) return;

		if (
			values.tipoDocumento === "CPF" &&
			!documentoValido(values.numeroDocumento)
		) {
			setValidator((current) => ({ ...current, documento: "false" }));
			return;
		}
		if (values.tipoDocumento === "CNH" && !cnhValido(values.numeroDocumento)) {
			setValidator((current) => ({ ...current, documento: "false" }));
			return;
		}
		if (!values.nomeEmergencia || values.nomeEmergencia === "") {
			setValidator((current) => ({ ...current, nomeEmergencia: "false" }));
			return;
		}
		if (!values.rg || values.rg === "") {
			setValidator((current) => ({ ...current, rg: "false" }));
			return;
		}
		if (!values.telefoneEmergencia || values.telefoneEmergencia === "") {
			setValidator((current) => ({ ...current, telefoneContato: "false" }));
			return;
		}
		if (!values.nome || values.nome === "") {
			setValidator((current) => ({ ...current, nome: "false" }));
			setTextoErroNome("Preencha o campo nome.");
			return;
		}
		if (!values.rua || values.rua === "") {
			setValidator((current) => ({ ...current, validatorRua: "false" }));
			return;
		}
		if (!values.bairro || values.bairro === "") {
			setValidator((current) => ({ ...current, validatorBairro: "false" }));
			return;
		}
		if (!values.numero || values.numero === "") {
			setValidator((current) => ({ ...current, validatorNumero: "false" }));
			return;
		}
		if (!values.cidade || values.cidade === "") {
			setValidator((current) => ({ ...current, validatorCidade: "false" }));
			return;
		}
		if (!values.cep || values.cep === "") {
			setValidator((current) => ({ ...current, validatorCep: "false" }));
			return;
		}

		if (
			validator.nome === "false" ||
			validator.telefone === "false" ||
			validator.telefoneContato === "false" ||
			validator.documento === "false" ||
			validator.nomeEmergencia === "false" ||
			validator.rg === "false"
		) {
			setTextoErro(
				"Preencha todos os campos corretamente, inclusive endereço."
			);
			setOpenToastErro(true);
			return;
		}

		setLoading(true);
		const valuesFormat = formatMotora(values);

		await cadastraMotorista(valuesFormat, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setValues({});
					setValuesSelect({});
					setTelaCadastro(false);
					if (!valuesPesquisa.pesquisa) {
						buscarMotorista();
					} else {
						buscarSearch();
					}
					shouldSearchDependencies();
					setDadosRequestControllerRedux("Fechar Modal Motorista");
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [
		values,
		valuesPesquisa,
		buscarMotorista,
		buscarSearch,
		validarTelefones,
		shouldSearchDependencies,
		setDadosRequestControllerRedux,
		setTabelaRedux,
		validator.documento,
		validator.nome,
		validator.nomeEmergencia,
		validator.rg,
		validator.telefone,
		validator.telefoneContato,
		profile?.token,
	]);

	const editar = useCallback(async () => {
		setOpenToastErro(false);

		if (!validarTelefones()) return;
		if (
			values.tipoDocumento === "CPF" &&
			!documentoValido(values.numeroDocumento)
		) {
			setValidator((current) => ({ ...current, documento: "false" }));
			return;
		}
		if (values.tipoDocumento === "CNH" && !cnhValido(values.numeroDocumento)) {
			setValidator((current) => ({ ...current, documento: "false" }));
			return;
		}
		if (!values.nomeEmergencia || values.nomeEmergencia === "") {
			setValidator((current) => ({ ...current, nomeEmergencia: "false" }));
			return;
		}
		if (!values.rg || values.rg === "") {
			setValidator((current) => ({ ...current, rg: "false" }));
			return;
		}
		if (!values.telefoneEmergencia || values.telefoneEmergencia === "") {
			setValidator((current) => ({ ...current, telefoneContato: "false" }));
			return;
		}
		if (!values.nome || values.nome === "") {
			setValidator((current) => ({ ...current, nome: "false" }));
			setTextoErroNome("Preencha o campo nome.");
			return;
		}

		if (
			validator.nome === "false" ||
			validator.telefone === "false" ||
			validator.telefoneContato === "false" ||
			validator.documento === "false" ||
			validator.nomeEmergencia === "false" ||
			validator.rg === "false"
		) {
			setTextoErro(
				"Preencha todos os campos corretamente, inclusive endereço."
			);
			setOpenToastErro(true);
			return;
		}

		if (!values.rua || values.rua === "") {
			setValidator((current) => ({ ...current, validatorRua: "false" }));
			return;
		}
		if (!values.bairro || values.bairro === "") {
			setValidator((current) => ({ ...current, validatorBairro: "false" }));
			return;
		}
		if (!values.numero || values.numero === "") {
			setValidator((current) => ({ ...current, validatorNumero: "false" }));
			return;
		}
		if (!values.cidade || values.cidade === "") {
			setValidator((current) => ({ ...current, validatorCidade: "false" }));
			return;
		}
		if (!values.cep || values.cep === "") {
			setValidator((current) => ({ ...current, validatorCep: "false" }));
			return;
		}

		if (
			validator.validatorRua === "false" ||
			validator.validatorNumero === "false" ||
			validator.validatorCep === "false" ||
			validator.validatorCidade === "false" ||
			validator.validatorBairro === "false"
		) {
			setTextoErro("Endereço obrigatório.");
			setOpenToastErro(true);
			return;
		}

		setLoading(true);

		const valuesFormat = formatMotora(values);
		await editaMotoristaPorId(valuesFormat, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (valuesPesquisa.pesquisa === undefined) {
						buscarMotorista();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					setTextoSucesso("Editado Com Sucesso");
					setOpenToastSucesso(true);
					setTelaCadastro(false);
					setEditando(false);
					hasBuscadoMotoristaId.current = false;
					setValues({});
					setValuesSelect({});
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	}, [
		values,
		valuesPesquisa,
		buscarMotorista,
		buscarSearch,
		validarTelefones,
		shouldSearchDependencies,
		setDadosRequestControllerRedux,
		setTabelaRedux,
		validator.documento,
		validator.nome,
		validator.nomeEmergencia,
		validator.rg,
		validator.telefone,
		validator.telefoneContato,
		profile?.token,
	]);

	const [motoristaId, setMotoristaId] = useState(0);

	const buscarMotoristaPorId = async () => {
		setLoading(true);
		await getMotoristaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					hasBuscadoMotoristaId.current = true;
					if (editando) {
						await preencherDadosEditando(result.data);
						setValues(result.data);
						setMotoristaId(result.data.idMotorista);
						setLoading(false);
						setValues((current) => ({
							...current,
							nomeBackup: result.data.nome,
						}));
						if (!!result.data.endereco) {
							setValues((current) => ({
								...current,
								rua: result.data.endereco.rua,
								numero: result.data.endereco.numero,
								cidade: result.data.endereco.cidade,
								cep: result.data.endereco.cep,
								bairro: result.data.endereco.bairro,
								complemento: result.data.endereco.complemento,
							}));
						}
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarMotoristaPorIdModal = async (id) => {
		setLoading(true);
		await getMotoristaPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					hasBuscadoMotoristaId.current = true;
					await preencherDadosEditando(result.data);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarMotoristaPorId = async () => {
		setLoading(true);
		await deleteMotoristaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarMotorista();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (profile?.token && editando && !hasBuscadoMotoristaId.current) {
			buscarMotoristaPorId();
		}
	}, [editando, profile?.token, buscarMotoristaPorId]);

	useEffect(() => {
		if (props.telaCadastro && profile?.token) {
			setTelaCadastro(true);
		}
		if (props.idAtual && profile?.token) {
			buscarMotoristaPorIdModal(props.idAtual);
		}
	}, [
		props.telaCadastro,
		props.idAtual,
		profile?.token,
		buscarMotoristaPorIdModal,
	]);

	const biggerDevice = useMemo(() => {
		return window.innerWidth >= 1450;
	}, []);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Motorista"));
			buscarMotorista();
			buscarUsuariosClientes();
		}
	}, [profile?.token]);

	const labelFrota = (data) => <div>{data.opcao}</div>;

	const opcoesFrota = opcoes.map((data) => ({
		value: data.opcao,
		label: data.opcao,
		...data,
	}));

	const estiloFrota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	useEffect(() => {
		setOpenToastErro(false);
		setOpenToastSucesso(false);
		setValidator((current) => ({
			...current,
			nome: "true",
			telefone: "true",
			telefoneContato: "true",
			numeroDocumento: "true",
			nomeEmergencia: "true",
			rg: "true",
		}));
	}, [telaCadastro, editando]);

	const isLoading = useMemo(() => {
		return loading || !profile?.token || !dadosTabela;
	}, [loading, dadosTabela, profile?.token]);

	const cadastroString = useMemo(() => {
		return editando ? "Detalhes do Motorista" : "Cadastro de Motorista";
	}, [editando]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer animationKey="MotoristaScreenContainer">
						<div className="content-container">
							<div>
								<Separator size="md" />
								<FiltroV2
									classe="div-filtrar-embarque-v2"
									classOption="select-options-cliente"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
								<Separator size="md" />
							</div>
							<TabelaVirtualizadaGenerica
								dados={dadosTabela}
								colunas={tabelaEmpresa.Motorista}
								rowHeight={20}
								isLoading={isLoading}
								getRowClassName={getRowClassName}
								onRowClick={handleRowClick}
								centralized={biggerDevice}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer scroll animationKey="MotoristaCadastroContainer">
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Motorista / "}</p>
										<p className="indicador-emb">{cadastroString}</p>
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setValuesSelect({});
													setTelaCadastro(false);
													setEditando(false);
													hasBuscadoMotoristaId.current = false;
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.nome === "false" ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Luiz Carlos"
													maxLength={24}
													onBlur={(e) => {
														verificadorExistenciaMotorista(e.target.value);
													}}
													value={values.nome || ""}
													disabled={props.desabilitar}
												/>
												{validator.nome === "false" && (
													<div className="error-input-text">
														{textoErroNome}
													</div>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Telefone:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.telefone === "false" ? "red" : "",
													}}
													onChange={handleChangePhone}
													placeholder="(99)99999-9999"
													value={telefoneMask(values.telefone) || ""}
													disabled={props.desabilitar}
												/>
												{validator.telefone === "false" && (
													<div className="error-input-text">
														Telefone invalido.
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Número Documento:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.documento === "false" ? "red" : "",
													}}
													onChange={handleChangeDocumento}
													placeholder="999-999-999-99"
													value={values.numeroDocumento || ""}
													disabled={props.desabilitar}
												/>
												{validator.documento === "false" && (
													<div className="error-input-text">
														Documento invalido.
													</div>
												)}
											</div>
											{validator.documento === "false" && (
												<div className="error-input-text">
													Documento invalido.
												</div>
											)}
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Tipo Documento:
												</p>
												<FormControl sx={{ width: 270 }}>
													<ReactSelect
														value={valuesSelect.tipoDocumento || ""}
														options={opcoesFrota}
														formatOptionLabel={labelFrota}
														styles={estiloFrota}
														placeholder="Selecione"
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	tipoDocumento: selectedOption.opcao,
																}));
																setValuesSelect((current) => ({
																	...current,
																	tipoDocumento: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	tipoDocumento: "true",
																}));
															}
														}}
													/>
												</FormControl>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Contato de Emergência:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.nomeEmergencia === "false" ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nomeEmergencia: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nomeEmergencia: "true",
														}));
													}}
													placeholder="Irmão"
													value={values.nomeEmergencia || ""}
													disabled={props.desabilitar}
												/>
												{validator.nomeEmergencia === "false" && (
													<div className="error-input-text">
														Nome de emergência inválido.
													</div>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Telefone de Emergência:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.telefoneContato === "false"
																? "red"
																: "",
													}}
													onChange={handleChangePhoneEmergencia}
													placeholder="(99)99999-9999"
													value={telefoneMask(values.telefoneEmergencia) || ""}
													disabled={props.desabilitar}
												/>
												{validator.telefoneContato === "false" && (
													<div className="error-input-text">
														Telefone invalido.
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													RG:
												</p>
												<input
													type="text"
													className="input-emb"
													maxLength={9}
													style={{
														width: "270px",
														borderColor: validator.rg === "false" ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															rg: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															rg: "true",
														}));
													}}
													value={values.rg || ""}
													disabled={props.desabilitar}
												/>
												{validator.rg === "false" && (
													<div className="error-input-text">RG inválido.</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="flex">
												<input
													className="checkcheck"
													type="checkbox"
													checked={values.frota}
													disabled={props.desabilitar}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															frota: e.target.checked,
														}));
													}}
												/>
												<InputLabel htmlFor="status">
													<Text texto="Frota" />
												</InputLabel>
											</div>
										</div>
										<div className="input-box-container">
											<div className="flex">
												<input
													type="checkbox"
													className="checkcheck"
													checked={values.bloqueado}
													onChange={(e) => {
														if (e.target.checked === true) {
															setVerificaMotivo(false);
														} else {
															setVerificaMotivo(true);
														}
														setValues((current) => ({
															...current,
															bloqueado: e.target.checked,
														}));
													}}
												/>
												<InputLabel htmlFor="status">
													<Text texto="Bloqueado" />
												</InputLabel>
											</div>
										</div>
										{values.bloqueado && (
											<div className="input-box-container">
												<div>
													<p className="input-label-emb" htmlFor="descricao">
														Motivo:
													</p>
													<input
														type="text"
														className="input-emb"
														style={{ width: "370px" }}
														onChange={(e) => {
															setValues((current) => ({
																...current,
																motivo: e.target.value,
															}));
														}}
														placeholder=""
														value={values.motivo || ""}
														disabled={props.desabilitar}
													/>
												</div>
											</div>
										)}
									</div>{" "}
									<MotoristaEndereco
										validator={validator}
										setValues={setValues}
										setValidator={setValidator}
										values={values}
										props={props}
										setTextoErro={setTextoErro}
										setOpenToastErro={setOpenToastErro}
									/>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
									}}
								/>
							) : (
								<>
									{!props.desabilitar &&
										(props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													cadastrar();
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													cadastrar();
												}}
											/>
										))}
								</>
							)}
							{!props.botaoVoltar && (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesSelect({});
										setTelaCadastro(false);
										setEditando(false);
										hasBuscadoMotoristaId.current = false;
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
						{editando && (
							<>
								<TipoObservacao
									navbar="nao"
									botaoCadastrar="nao"
									telaCadastro={false}
									idAtual={props.idAtual}
									desabilitar={props.desabilitar}
									motoristaId={motoristaId}
								/>
								<div
									style={{
										height: 2,
										width: "100%",
										backgroundColor: "#3e3e3e",
										marginTop: 12,
										marginBottom: 12,
									}}
								/>
								<TipoContatoProp
									navbar="nao"
									botaoVoltar="nao"
									botaoCadastrar="nao"
									telaCadastro={false}
									idAtual={props.idAtual}
									desabilitar={props.desabilitar}
									motoristaId={motoristaId}
								/>
							</>
						)}
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarMotoristaPorId}
				/>
				<ModalConfirmacao2
					titulo="Deseja Fechar? "
					texto="Ao fechar esse modal não será mais possivel visalizar a senha."
					textoBotao="Sim"
					open={openConfirmar}
					onClose={handleCloseConfirmar}
					onClick={handleCloseUsuarioMotorista}
				/>
				<ModalVincular
					titulo="Vincular Usuário"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={openGerar}
					onClose={handleCloseGerar}
					onClick={clickGerar}
					listaUsuarios={listaUsuarios}
					setUsuarioId={setUsuarioId}
					setNomeUsuario={setNomeUsuario}
					referenciaId="nome"
					referenciaItem="nome"
					id="id"
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
				<ModalUsuarioMotorista
					titulo="Login Motorista"
					tituloConfirmar="OK"
					open={openUsuarioMotorista}
					onClose={abrirConfirmar}
					dados={dadosUsuarioMotorista}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default Motorista;
